import { render, staticRenderFns } from "./skuDistributionPrice.vue?vue&type=template&id=488f8df8&"
import script from "./skuDistributionPrice.vue?vue&type=script&lang=js&"
export * from "./skuDistributionPrice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports